export enum ResponseIndices {
	NoneOption = -1,
	OtherOption = -2,
}
